import React from 'react';
import SCAProbabilityComponent from "./SCAProbabilityComponent";


const SCAProbabilityContainer = (props) => {
	return (
		<React.Fragment>
			<SCAProbabilityComponent SCAProbabilityRate={props.SCAProbabilityRate} /> 
		</React.Fragment>
	);

};


export default SCAProbabilityContainer;



// WEBPACK FOOTER //
// ./src/common/components/SCAProbability/SCAProbabilityContainer.js